<!--<link rel="stylesheet" href="../assets/layout/sass/_login.scss">-->
<template>
    <div :class="containerClass">
        <app-reset></app-reset>
    </div>
</template>

<script>
    import AppReset from '../components/Reset';

    export default {
        name: "Reset",
        computed: {
            containerClass() {
                return ['layout-wrapper', {
                    'layout-dark': this.$store.state.theme === 'dark',
                    'layout-light': this.$store.state.theme === 'light',
                }];
            },
        },
        components: {
            'AppReset': AppReset,
        }
    }

</script>

<style lang="scss">
    @import '../App.scss';

</style>